"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSES = void 0;
var CLASSES;
(function (CLASSES) {
    CLASSES["FLEXLAYOUT__BORDER"] = "flexlayout__border";
    CLASSES["FLEXLAYOUT__BORDER_"] = "flexlayout__border_";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON"] = "flexlayout__border_button";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_"] = "flexlayout__border_button_";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_CONTENT"] = "flexlayout__border_button_content";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_LEADING"] = "flexlayout__border_button_leading";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_TRAILING"] = "flexlayout__border_button_trailing";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON__SELECTED"] = "flexlayout__border_button--selected";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON__UNSELECTED"] = "flexlayout__border_button--unselected";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_OVERFLOW"] = "flexlayout__border_toolbar_button_overflow";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_OVERFLOW_"] = "flexlayout__border_toolbar_button_overflow_";
    CLASSES["FLEXLAYOUT__BORDER_INNER"] = "flexlayout__border_inner";
    CLASSES["FLEXLAYOUT__BORDER_INNER_"] = "flexlayout__border_inner_";
    CLASSES["FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER"] = "flexlayout__border_inner_tab_container";
    CLASSES["FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER_"] = "flexlayout__border_inner_tab_container_";
    CLASSES["FLEXLAYOUT__BORDER_SIZER"] = "flexlayout__border_sizer";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR"] = "flexlayout__border_toolbar";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_"] = "flexlayout__border_toolbar_";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON"] = "flexlayout__border_toolbar_button";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_FLOAT"] = "flexlayout__border_toolbar_button-float";
    CLASSES["FLEXLAYOUT__DRAG_RECT"] = "flexlayout__drag_rect";
    CLASSES["FLEXLAYOUT__EDGE_RECT"] = "flexlayout__edge_rect";
    CLASSES["FLEXLAYOUT__ERROR_BOUNDARY_CONTAINER"] = "flexlayout__error_boundary_container";
    CLASSES["FLEXLAYOUT__ERROR_BOUNDARY_CONTENT"] = "flexlayout__error_boundary_content";
    CLASSES["FLEXLAYOUT__FLOATING_WINDOW_CONTENT"] = "flexlayout__floating_window_content";
    CLASSES["FLEXLAYOUT__FLOATING_WINDOW_TAB"] = "flexlayout__floating_window_tab";
    CLASSES["FLEXLAYOUT__LAYOUT"] = "flexlayout__layout";
    CLASSES["FLEXLAYOUT__OUTLINE_RECT"] = "flexlayout__outline_rect";
    CLASSES["FLEXLAYOUT__OUTLINE_RECT_EDGE"] = "flexlayout__outline_rect_edge";
    CLASSES["FLEXLAYOUT__SPLITTER"] = "flexlayout__splitter";
    CLASSES["FLEXLAYOUT__SPLITTER_EXTRA"] = "flexlayout__splitter_extra";
    CLASSES["FLEXLAYOUT__SPLITTER_"] = "flexlayout__splitter_";
    CLASSES["FLEXLAYOUT__SPLITTER_BORDER"] = "flexlayout__splitter_border";
    CLASSES["FLEXLAYOUT__SPLITTER_DRAG"] = "flexlayout__splitter_drag";
    CLASSES["FLEXLAYOUT__TAB"] = "flexlayout__tab";
    CLASSES["FLEXLAYOUT__TABSET"] = "flexlayout__tabset";
    CLASSES["FLEXLAYOUT__TABSET_HEADER"] = "flexlayout__tabset_header";
    CLASSES["FLEXLAYOUT__TABSET_HEADER_SIZER"] = "flexlayout__tabset_header_sizer";
    CLASSES["FLEXLAYOUT__TABSET_HEADER_CONTENT"] = "flexlayout__tabset_header_content";
    CLASSES["FLEXLAYOUT__TABSET_MAXIMIZED"] = "flexlayout__tabset-maximized";
    CLASSES["FLEXLAYOUT__TABSET_SELECTED"] = "flexlayout__tabset-selected";
    CLASSES["FLEXLAYOUT__TABSET_SIZER"] = "flexlayout__tabset_sizer";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER"] = "flexlayout__tabset_tabbar_inner";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER_"] = "flexlayout__tabset_tabbar_inner_";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER"] = "flexlayout__tabset_tabbar_inner_tab_container";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER_"] = "flexlayout__tabset_tabbar_inner_tab_container_";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_OUTER"] = "flexlayout__tabset_tabbar_outer";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_OUTER_"] = "flexlayout__tabset_tabbar_outer_";
    CLASSES["FLEXLAYOUT__TAB_BORDER"] = "flexlayout__tab_border";
    CLASSES["FLEXLAYOUT__TAB_BORDER_"] = "flexlayout__tab_border_";
    CLASSES["FLEXLAYOUT__TAB_BUTTON"] = "flexlayout__tab_button";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_CONTENT"] = "flexlayout__tab_button_content";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_LEADING"] = "flexlayout__tab_button_leading";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_OVERFLOW"] = "flexlayout__tab_button_overflow";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_OVERFLOW_COUNT"] = "flexlayout__tab_button_overflow_count";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_TEXTBOX"] = "flexlayout__tab_button_textbox";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_TRAILING"] = "flexlayout__tab_button_trailing";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_STAMP"] = "flexlayout__tab_button_stamp";
    CLASSES["FLEXLAYOUT__TAB_FLOATING"] = "flexlayout__tab_floating";
    CLASSES["FLEXLAYOUT__TAB_FLOATING_INNER"] = "flexlayout__tab_floating_inner";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR"] = "flexlayout__tab_toolbar";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON"] = "flexlayout__tab_toolbar_button";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON_"] = "flexlayout__tab_toolbar_button-";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON_FLOAT"] = "flexlayout__tab_toolbar_button-float";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_STICKY_BUTTONS_CONTAINER"] = "flexlayout__tab_toolbar_sticky_buttons_container";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON_CLOSE"] = "flexlayout__tab_toolbar_button-close";
    CLASSES["FLEXLAYOUT__POPUP_MENU_CONTAINER"] = "flexlayout__popup_menu_container";
    CLASSES["FLEXLAYOUT__POPUP_MENU_ITEM"] = "flexlayout__popup_menu_item";
    CLASSES["FLEXLAYOUT__POPUP_MENU"] = "flexlayout__popup_menu";
})(CLASSES = exports.CLASSES || (exports.CLASSES = {}));
//# sourceMappingURL=Types.js.map